/* tslint:disable */
/* eslint-disable */
/**
 * Mailbox API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { MailboxItemDTO } from './MailboxItemDTO';
import {
    MailboxItemDTOFromJSON,
    MailboxItemDTOFromJSONTyped,
    MailboxItemDTOToJSON,
    MailboxItemDTOToJSONTyped,
} from './MailboxItemDTO';

/**
 * 
 * @export
 * @interface MailboxThreadDTO
 */
export interface MailboxThreadDTO {
    /**
     * 
     * @type {MailboxItemDTO}
     * @memberof MailboxThreadDTO
     */
    Item?: MailboxItemDTO;
    /**
     * 
     * @type {Array<MailboxItemDTO>}
     * @memberof MailboxThreadDTO
     */
    Thread?: Array<MailboxItemDTO> | null;
}

/**
 * Check if a given object implements the MailboxThreadDTO interface.
 */
export function instanceOfMailboxThreadDTO(value: object): value is MailboxThreadDTO {
    return true;
}

export function MailboxThreadDTOFromJSON(json: any): MailboxThreadDTO {
    return MailboxThreadDTOFromJSONTyped(json, false);
}

export function MailboxThreadDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): MailboxThreadDTO {
    if (json == null) {
        return json;
    }
    return {
        
        'Item': json['Item'] == null ? undefined : MailboxItemDTOFromJSON(json['Item']),
        'Thread': json['Thread'] == null ? undefined : ((json['Thread'] as Array<any>).map(MailboxItemDTOFromJSON)),
    };
}

export function MailboxThreadDTOToJSON(json: any): MailboxThreadDTO {
    return MailboxThreadDTOToJSONTyped(json, false);
}

export function MailboxThreadDTOToJSONTyped(value?: MailboxThreadDTO | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'Item': MailboxItemDTOToJSON(value['Item']),
        'Thread': value['Thread'] == null ? undefined : ((value['Thread'] as Array<any>).map(MailboxItemDTOToJSON)),
    };
}

